/**
 * Copyright (c) [2015-2020] SUSE Linux
 *
 * This software may be modified and distributed under the terms
 * of the MIT license.  See the LICENSE.txt file for details.
 */
import React from 'react';
import { useDispatch } from 'react-redux';
import { actionCreators as chatActions } from '../../../state/ducks/messages';

function handleSubmit(event, dispatch, textInput) {
  event.preventDefault();

  const text = textInput.current.value;

  // TODO: validate data and give feedback
  dispatch(chatActions.send(text));
  textInput.current.value = '';
}

function MessageForm() {
  const textInput = React.createRef();
  const dispatch = useDispatch();

  return (
    <form
      data-testid="chatbox"
      className="flex w-full p-2 bg-gray-800 rounded-lg border border-gray-700"
      onSubmit={(event) => handleSubmit(event, dispatch, textInput)}>
      <input
        id="text"
        type="text"
        autoComplete="off"
        className="flex-grow mr-2 px-4 py-3 bg-gray-700 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent"
        placeholder="请输入消息"
        ref={textInput}
      />
      <input
        type="submit"
        className="px-6 py-3 bg-secondary hover:bg-secondary-lighter text-white font-semibold rounded-lg transition-colors duration-200"
        value="发送"
      />
    </form>
  );
}

export default MessageForm;
